import produce from 'immer';

import {
  CLEAR_PRODUCT_LAYOUT,
  PRODUCT_LAYOUT_EDIT_SEQUENCE_FAILURE,
  PRODUCT_LAYOUT_EDIT_SEQUENCE_SUCCESS,
  PRODUCT_LAYOUT_FETCH_FAILURE,
  PRODUCT_LAYOUT_FETCH_SUCCESS,
  PRODUCT_LAYOUT_FETCH_REQUEST,
} from '@actions/productLayout';

const initialState: IProductLayoutStore = {
  productLayout: null,
  isFetching: false,
  error: null,
};

export default (state: IProductLayoutStore = initialState, action: any) =>
  produce(state, (draftState: IProductLayoutStore) => {
    switch (action.type) {
      case PRODUCT_LAYOUT_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.productLayout = null;
        draftState.error = null;

        return;

      case PRODUCT_LAYOUT_EDIT_SEQUENCE_SUCCESS:
      case PRODUCT_LAYOUT_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.productLayout = action.response;
        draftState.error = null;

        return;

      case PRODUCT_LAYOUT_EDIT_SEQUENCE_FAILURE:
      case PRODUCT_LAYOUT_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.error;

        return;

      case CLEAR_PRODUCT_LAYOUT:
        draftState.productLayout = null;

        return;
    }
  });
